import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import {
	makeStyles
} from '@material-ui/core';

import Constants from "../utils/Constants";
import {useSelectedSubNavTab} from "../utils/CustomHooks";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import ReportsTabs from "../components/ReportsTabs";
import SubNavPanelsWrapper from "../components/SubNavPanelsWrapper";
import OverviewReport from "../reports/containers/OverviewReport";
import UserEngagementReport from "../reports/containers/UserEngagementReport";
import SocialMediaOverviewReport from "../reports/containers/SocialMediaOverviewReport";
import GSuiteOverviewReport from "../reports/containers/GSuiteOverviewReport";
import StaticGsuiteOverviewReport from "../reports/containers/StaticGsuiteOverviewReport";
import ExchangeOverviewReport from "../reports/containers/ExchangeOverviewReport";
import StaticEmailOverviewReport from "../reports/containers/StaticEmailOverviewReport";
import WebSearchOverviewReport from "../reports/containers/WebSearchOverviewReport";
import StaticWebSearchOverviewReport from "../reports/containers/StaticWebSearchOverviewReport";
import ShareitOverviewReport from "../reports/containers/ShareitOverviewReport";
import AccountAuditTrail from "../reports/containers/AccountAuditTrail";
import AlertSummary from "../reports/containers/AlertSummary";

const styles = makeStyles(theme => ({
	fullScreenClassName: {
		[theme.breakpoints.only('md')]: {
			paddingTop: `${theme.spacing(28.125)}px !important`
		}
	}
}));

function Reports(props) {
	const authenticatedUser = useContext(AuthorizedUserContext);
	const [selectedTab, setSelectedTab] = useState(false);
	const tabs = ["overview", "social-media", "gsuite", "outlook", "shareit", "audit-trail", "alert-summary", "web-search"];

	let classes = styles(),
		{location, updateHeader, resetHeader, showSnackbar, csm,
			setFullScreenClassName, setBannerClassName, hasNudgeBanner} = props,
		fullScreenClassName = classes.fullScreenClassName;

	const getSelectedTab = useSelectedSubNavTab(location, tabs);

	useEffect(() => {
		updateHeader({title: "reports", primary: true});
		return () => resetHeader();
	}, [updateHeader, resetHeader]);

	useEffect(() => {
		setSelectedTab(getSelectedTab());
	}, [getSelectedTab, setSelectedTab]);

	useEffect(() => {
		setFullScreenClassName(fullScreenClassName);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const tabClicked = (event, tab) => {
		setSelectedTab(tab);
		props.history.push(`/reports/${tab}`);
	};

	/*
	moreContrast = AuthorizedUser.wantsMoreContrast(),
	currentPath = `${window.location.pathname}${window.location.search}`,
	exchangeReportPath = authenticatedUser.isDemo ? "/static-exchange-report" : "/exchange-report",
	*/

	return (
		<React.Fragment>
			<ReportsTabs
				selectedTab={selectedTab}
				tabClicked={tabClicked}
				hasNudgeBanner={hasNudgeBanner}
				setBannerClassName={setBannerClassName} />
			<SubNavPanelsWrapper>
				{selectedTab === tabs[0] ?
					<Switch>
						<Route
							path="/reports/overview/user-engagement"
							render={() => (
								<UserEngagementReport
									{...props}
									showSnackbar={showSnackbar}
									updateHeader={updateHeader}
									resetHeader={resetHeader} />
							)} />

						<Route
							path="/reports/overview"
							render={() => (
								<OverviewReport
									{...props}
									csm={csm}
									updateHeader={updateHeader}
									resetHeader={resetHeader}
									showSnackbar={showSnackbar} />
							)} />
					</Switch> : null
				}
				{selectedTab === tabs[1] ?
					<SocialMediaOverviewReport
						{...props}
						csm={csm}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar} /> : null
				}
				{selectedTab === tabs[2] ?
					authenticatedUser.isDemo ?
						<StaticGsuiteOverviewReport
							{...props}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							source={Constants.SOURCES.GSUITE} />
						:
						<GSuiteOverviewReport
							{...props}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							source={Constants.SOURCES.GSUITE} /> : null
				}
				{selectedTab === tabs[3] ?
					authenticatedUser.isDemo ?
						<StaticEmailOverviewReport
							{...props}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							source={Constants.SOURCES.EXCHANGE} />
						:
						<ExchangeOverviewReport
							{...props}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							source={Constants.SOURCES.EXCHANGE} /> : null
				}
				{selectedTab === tabs[7] ?
					authenticatedUser.isDemo ?
						<StaticWebSearchOverviewReport
							{...props}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							source={Constants.SOURCES.WEB_SEARCH} />
						:
						<WebSearchOverviewReport
							{...props}
							updateHeader={updateHeader}
							resetHeader={resetHeader}
							showSnackbar={showSnackbar}
							source={Constants.SOURCES.WEB_SEARCH} /> : null
				}
				{selectedTab === tabs[4] ?
					<ShareitOverviewReport
						{...props}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar} /> : null
				}
				{selectedTab === tabs[5] ?
					<AccountAuditTrail
						{...props}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar} /> : null
				}
				{selectedTab === tabs[6] ?
					<AlertSummary
						{...props}
						updateHeader={updateHeader}
						resetHeader={resetHeader}
						showSnackbar={showSnackbar} /> : null
				}
			</SubNavPanelsWrapper>
		</React.Fragment>
	);
}

Reports.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	csm: PropTypes.object.isRequired,
	setBannerClassName: PropTypes.func.isRequired,
	hasNudgeBanner: PropTypes.bool,
	setFullScreenClassName: PropTypes.func
};

export default Reports;